import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _getIterator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/get-iterator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from '~/api/api.js';
import toast from '~/components/toast.vue';
import upload from '~/components/upload.vue';
import FormData from 'form-data';
import isButton from '~/components/button.vue';

// import Dropzone from 'nuxt-dropzone'
// import 'nuxt-dropzone/dropzone.css'
// let userData = ''
var miniToastr = void 0;
if (process.browser) {
  miniToastr = require('mini-toastr');
}

export default {
  middleware: ['auth', 'authorizeCustomer'],
  mounted: function mounted() {
    miniToastr.init();
    // const instance = this.$refs.el.dropzone
  },

  notifications: {
    showLoginError: {
      title: '',
      message: 'Hello from nuxt.js',
      type: 'error'
    },
    showSuccess: {
      title: 'Success',
      message: '',
      type: 'success'
    }
  },
  props: ['tokenData', 'createByID'],
  //   async asyncData({ store, query, error }) {
  //     userData = store.state.authUser
  //     if (userData.roleID !== 'Admin' && userData.roleID !== 'Customer') {
  //       return error({ statusCode: 401, message: 'Permision Denied' })
  //     }
  //     return {
  //       tokenData: userData
  //     }
  //   },
  data: function data() {
    var userModel = {
      projectName: '',
      partName: '',
      partNumber: '',
      typeOfProduct: '',
      material: '',
      hardening: '',
      plating: '',
      quantity: '',
      dataInspection: [],
      description: '',

      engineerService: 'No'
    };

    return {
      productTypeCustom: false,
      materialCustomer: false,
      platingCustom: false,
      user: userModel,
      progressLevel: '0',
      openSuccess: false,

      typeOfProduct: ['Spare Part', 'Jig', 'Special Tool', 'Structural', 'Etc.'],
      material: [{ name: 'Carbon Steel', open: false }, { name: 'SUS', open: false }, { name: 'Brass', open: false }, { name: 'Aluminium', open: false }, { name: 'Copper', open: false }],
      // tokenData: userData,
      displayData: 'display:none;',
      displayTypeOfProduct: 'display:none;',
      dpiTypeOfProduct: 'display:none;',
      dpsTypeOfProduct: '',
      dpiMaterial: 'display:none;',
      dpsMaterial: '',
      dpiPlating: 'display:none;',
      dpsPlating: ''
    };
  },


  methods: {
    selectETC: function selectETC() {
      if (this.user.typeOfProduct === 'Etc.' || this.user.typeOfProduct === '') {
        this.user.typeOfProduct = '';
        this.productTypeCustom = true;
      } else {
        this.productTypeCustom = false;
      }
    },
    selectPlating: function selectPlating() {
      if (this.user.plating === 'Etc' || this.user.plating === '') {
        this.user.plating = '';
        this.platingCustom = true;
      } else {
        this.platingCustom = false;
      }
    },
    selectMaterial: function selectMaterial() {
      if (this.user.material === 'Etc.' || this.user.material === '') {
        this.user.material = '';
        this.materialCustomer = true;
      } else {
        this.materialCustomer = false;
      }
    },
    clearTypeOfProduct: function clearTypeOfProduct() {
      this.user.typeOfProduct = '';
      this.productTypeCustom = false;
    },
    clearPlating: function clearPlating() {
      this.user.plating = '';
      this.platingCustom = false;
    },
    clearMaterial: function clearMaterial() {
      this.user.material = '';
      this.materialCustomer = false;
    },
    typeOfProductEtc: function typeOfProductEtc() {
      if (this.user.typeOfPainting === 'Etc.') {
        this.displayData = '';
      } else {
        this.displayData = 'display:none;';
      }
    },
    onProgress: function onProgress(percent) {
      this.progressLevel = percent + '';
    },
    createProject: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var items, button, formData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, result;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                items = this.$refs.upload.getItems();
                button = this.$refs.btnCreate;

                if (!(this.user.projectName === '')) {
                  _context.next = 6;
                  break;
                }

                this.showLoginError({ message: 'Please insert Project Name' });
                button.enabled();
                return _context.abrupt('return', false);

              case 6:
                if (!(this.user.partName === '')) {
                  _context.next = 10;
                  break;
                }

                this.showLoginError({ message: 'Please insert Part Name' });
                button.enabled();
                return _context.abrupt('return', false);

              case 10:
                if (!(this.user.partNumber === '')) {
                  _context.next = 14;
                  break;
                }

                this.showLoginError({ message: 'Please insert Part Number' });
                button.enabled();
                return _context.abrupt('return', false);

              case 14:
                if (!(this.user.detail === '')) {
                  _context.next = 18;
                  break;
                }

                this.showLoginError({ message: 'Please insert Project Detail' });
                button.enabled();
                return _context.abrupt('return', false);

              case 18:
                if (!(this.user.typeOfProduct === '')) {
                  _context.next = 22;
                  break;
                }

                this.showLoginError({
                  message: 'Please insert Project Type Of Product'
                });
                button.enabled();
                return _context.abrupt('return', false);

              case 22:
                if (!(this.user.material === '')) {
                  _context.next = 26;
                  break;
                }

                this.showLoginError({ message: 'Please insert Material' });
                button.enabled();
                return _context.abrupt('return', false);

              case 26:
                if (!(this.user.quantity === '')) {
                  _context.next = 30;
                  break;
                }

                this.showLoginError({ message: 'Please insert quantity' });
                button.enabled();
                return _context.abrupt('return', false);

              case 30:

                this.$refs.upload.uploadState();

                _context.next = 33;
                return API.setToken(this.tokenData.tokenID);

              case 33:
                formData = new FormData(); // Currently empty

                formData.append('projectName', this.user.projectName);
                formData.append('partName', this.user.partName);
                formData.append('partNumber', this.user.partNumber);
                formData.append('typeOfProduct', this.user.typeOfProduct);
                formData.append('material', this.user.material);
                formData.append('hardening', this.user.hardening);
                formData.append('plating', this.user.plating);
                formData.append('quantity', this.user.quantity);
                formData.append('dataInspection', this.user.dataInspection.join());
                formData.append('detail', this.user.description);
                formData.append('engineerService', this.user.engineerService);
                formData.append('createByID', this.createByID);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 49;
                for (_iterator = _getIterator(items); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  file = _step.value;

                  formData.append('fileUpload', file.file, file.file.name);
                }
                // cc
                _context.next = 57;
                break;

              case 53:
                _context.prev = 53;
                _context.t0 = _context['catch'](49);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 57:
                _context.prev = 57;
                _context.prev = 58;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 60:
                _context.prev = 60;

                if (!_didIteratorError) {
                  _context.next = 63;
                  break;
                }

                throw _iteratorError;

              case 63:
                return _context.finish(60);

              case 64:
                return _context.finish(57);

              case 65:
                _context.next = 67;
                return API.createProject(formData, this.onProgress);

              case 67:
                result = _context.sent;

                if (!(result.data.flag === true)) {
                  _context.next = 74;
                  break;
                }

                this.showSuccess({ message: result.data.message });
                this.openSuccess = true;
                if (this.tokenData.roleID.toLowerCase() === 'customer') {
                  window.location.href = '/customer/project/' + result.data.datas.projectID;
                } else {
                  window.location.href = '/project/' + result.data.datas.projectID;
                }
                _context.next = 77;
                break;

              case 74:
                this.showLoginError({ message: result.data.message });
                button.enabled();
                return _context.abrupt('return', false);

              case 77:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[49, 53, 57, 65], [58,, 60, 64]]);
      }));

      function createProject() {
        return _ref.apply(this, arguments);
      }

      return createProject;
    }()
  },
  components: {
    toast: toast,
    upload: upload,
    isButton: isButton
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/create-project.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/create-project.vue
// module chunks = 13 14